import { decode, encode } from '@msgpack/msgpack';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FN_SERIALIZATION__data_deserialize } from '@shared/serialization/FN_SERIALIZATION__data_deserialize';
import { Socket } from 'socket.io-client';
import { try_log_client_to_server } from '../send_to_server';
import { service_socketio_client } from '../service_socketio_client';

interface EventsMap {
  [event: string]: any;
}

type CALLBACK__emit = (response: any, response_packed: Uint8Array, outcoming_requests_number: number) => void;

type EventParams<Map extends EventsMap, Ev extends EventNames<Map>> = Parameters<Map[Ev]>;

type EventNames<Map extends EventsMap> = keyof Map & (string | symbol);

export function SOCKETIO_MIDDLEWARE__emit(socket: Socket) {
  // Save original socket.emit method
  const original_function_emit = socket.emit.bind(socket);

  // Override the socket.emit method to apply the middleware
  socket.emit = function <Ev extends EventNames<EventsMap>>(ev: Ev, ...args: EventParams<EventsMap, Ev>): Socket {
    // Transform data before sending if it has a type
    const data = args[0] as any; // Assuming the first argument is the data

    let data_packed = encode(data);

    let outcoming_requests_number = NaN;
    if (!CONSTANTS__shared.NETWORK_EVENTS_AUTOMATED.includes(ev)) {
      service_socketio_client.outcoming_requests_number++;
      outcoming_requests_number = service_socketio_client.outcoming_requests_number;
    }

    try_log_client_to_server(ev, data_packed, outcoming_requests_number);

    // Call the original socket.emit method
    original_function_emit(ev, data_packed, (...responses: any[]) => {
      let response_packed = responses[0];

      let response = response_packed == null ? response_packed : decode(response_packed);

      // Process the response from the server
      const response_deserialized = FN_SERIALIZATION__data_deserialize(response);

      // Call the original callback with the transformed response
      if (responses.length > 0) {
        let callback = args[args.length - 1] as CALLBACK__emit;
        // Pass the transformed response back to the original callback
        callback(response_deserialized, response_packed, outcoming_requests_number);
      }
    });

    return this; // Ensure the method returns the correct context
  };
}
